import { FloatingLabel } from '@/shared/theme/styled-components'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'
import { PulseFieldLabel } from './styled-components'

interface SDFieldLabelProps {
  // HTML: labels carry the required-field asterisk markup
  label: string
  FloatingLabelComponent?: typeof FloatingLabel
}

const SDFieldLabel = ({ label, FloatingLabelComponent = FloatingLabel }: SDFieldLabelProps) => {
  const isPulse = usePulseScope()

  if (isPulse) return <PulseFieldLabel dangerouslySetInnerHTML={{ __html: label }} />

  return (
    <FloatingLabelComponent>
      <div dangerouslySetInnerHTML={{ __html: label }} />
    </FloatingLabelComponent>
  )
}

export default SDFieldLabel
